import React from 'react';
import './App.css';
import { useScrollAnimation } from './hooks/useScrollAnimation';

import NewsTicker from './components/NewsTicker';
import HeroSection from './components/HeroSection';
import SymptomsSection from './components/SymptomsSection';
import GymSection from './components/GymSection';
import PainPointsSection from './components/PainPointsSection';
import StorySection from './components/StorySection';
import SectionSix from './components/SectionSix';
import ImagineSection from './components/ImagineSection';
import ExpertsSection from './components/ExpertsSection';
import CostSection from './components/CostSection';
import OfferSection from './components/OfferSection';
import ResultsSection from './components/ResultsSection';
import HowToBuySection from './components/HowToBuySection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';
import SectionDivider from './components/SectionDivider';
import PurchaseNotifications from './components/PurchaseNotifications';
import LegalModals from './components/LegalModals';

function App() {
  // Usa o hook de animação de scroll
  useScrollAnimation();

  return (
    <div className="App">

      <PurchaseNotifications />
      <NewsTicker />
      <HeroSection />
      <SectionDivider />
      <SymptomsSection />
      <SectionDivider />
      <GymSection />
      <SectionDivider />
      <PainPointsSection />
      <SectionDivider />
      <StorySection />
      <SectionDivider />
      <SectionSix />
      <SectionDivider />
      <ImagineSection />
      <SectionDivider />
      <ExpertsSection />
      <SectionDivider />
      <CostSection />
      <SectionDivider />
      <OfferSection />
      <SectionDivider />
      <ResultsSection />
      <SectionDivider />
      <HowToBuySection />
      <SectionDivider />
      <FaqSection />
      <Footer />
      <LegalModals />
    </div>
  );
}

export default App;
